import { render, staticRenderFns } from "./fts-page.vue?vue&type=template&id=3438dbda&scoped=true&"
import script from "./fts-page.vue?vue&type=script&lang=js&"
export * from "./fts-page.vue?vue&type=script&lang=js&"
import style0 from "./fts-page.vue?vue&type=style&index=0&id=3438dbda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3438dbda",
  null
  
)

export default component.exports